import React from 'react';

import classnames from 'classnames';

import classes from '@nerdwallet/base-styles/classes';
import { Box, Text, Type } from '@nerdwallet/currency';
import { Num as num } from '@nerdwallet/nw-client-lib';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

import ImageSizes from '../../../config/images/imageSizes';
import { formatResultForSegment } from '../../../lib/analytics/format-result-for-segment';
import SegmentImpression, {
  useSegmentImpressionContext,
} from '../../../lib/analytics/segment-impression';

import styles from './index.module.less';

interface MonthlyResultsProps {
  total: number;
  loanTerm: string;
  className?: string;
  headerText?: string;
  calculatorNameForSegment?: string;
}

const MonthlyResults: React.FC<MonthlyResultsProps> = ({
  total,
  loanTerm,
  className,
  headerText,
  calculatorNameForSegment,
}) => {
  const displayValue: number = num.formatCurrency(total);

  const { eventId: formViewedId } = useSegmentImpressionContext() || {};

  return (
    <div className={classnames(className, classes('position-relative'))}>
      <SegmentImpression
        enabled={Boolean(calculatorNameForSegment)}
        eventType="feature_viewed"
        attributes={{
          entity_name: 'form_result_text',
          section_name: 'form',
          item_position: null,
          item_copy: calculatorNameForSegment,
          content_id: null,
          additional_attributes: formatResultForSegment([
            { label: headerText, displayValue },
          ]),
          parent_event_id: formViewedId,
        }}
      >
        <Box className={classes('text-align-center')}>
          <Text size="default">{headerText}</Text>
          <Type size="4">{displayValue}</Type>
          <Type color="neutral-dark" size="2" fontFamily="gotham">
            {loanTerm}-year fixed loan term
          </Type>
        </Box>
      </SegmentImpression>
      <img
        className={classnames(styles.houseIcon, classes('position-absolute'))}
        {...ImageSizes.largeIcon.measures}
        alt=""
        src={iconUri('House_pricetag')}
      />
    </div>
  );
};

export default MonthlyResults;
